// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3Cdp4","selected":"Chip_selected__1Rj_c"};